import {
  divideRound,
  multiplyRound,
  addRound,
  subtractRound,
} from '@/libs/util.number.js'
// 定义一个对象构造函数

export const Calculator = {
  value: 0,
  init: function(val) {
    this.value = val || 0
    return this // 返回对象本身，以支持链式调用
  },
  add: function(num, y = 2) {
    this.value = addRound(this.value, num, y)
    return this // 返回对象本身，以支持链式调用
  },
  subtract: function(num, y = 2) {
    this.value = subtractRound(this.value, num, y)
    return this // 返回对象本身，以支持链式调用
  },
  multiply: function(num, y = 2) {
    this.value = multiplyRound(this.value, num, y)
    return this // 返回对象本身，以支持链式调用
  },

  divide: function(num, y = 2) {
    this.value = divideRound(this.value, num, y)
    return this // 返回对象本身，以支持链式调用
  },

  getResult: function() {
    return this.value
  },
}
